import React, { useEffect, useState } from 'react';
import Image, { ImageProps } from 'next/legacy/image';

export const TokenImage = React.memo(
  (props: ImageProps & { symbol: string }) => {
    const [src, setSrc] = useState(props.src);

    useEffect(() => {
      setSrc(props.src);
    }, [props.src]);

    const svg = generateTokenSVG(
      props.symbol,
      props.height ? parseInt(props.height.toString()) : 64
    );

    const base64 = Buffer.from(svg).toString('base64');
    const fallbackSrc = `data:image/svg+xml;base64,${base64}`;

    return <Image {...props} onError={() => setSrc(fallbackSrc)} src={src} />;
  }
);

function generateTokenSVG(symbol: string, size = 64): string {
  const bgColor = stringToHSL(symbol);
  const text = symbol.slice(0, 3);
  const fontSize = size * 0.4;

  return `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
  <circle cx="${size / 2}" cy="${size / 2}" r="${size / 2}" fill="${bgColor}" />
  <text x="50%" y="56%" dominant-baseline="middle" text-anchor="middle"
        font-size="${fontSize}" fill="#fff" font-family="Tahoma, sans-serif">
    ${text}
  </text>
</svg>
`.trim();
}

function stringToHSL(input: string): string {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = hash % 360;
  return `hsl(${hue}, 70%, 50%)`;
}
